import React, { useState, useEffect, useCallback } from 'react';

const pad = (n) => String(n).padStart(2, '0');

const Countdown = ({ target, label = 'Coming in' }) => {
  const compute = useCallback(() => {
    const diff = new Date(target).getTime() - Date.now();
    if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
    return {
      d: Math.floor(diff / 86400000),
      h: Math.floor((diff / 3600000) % 24),
      m: Math.floor((diff / 60000) % 60),
      s: Math.floor((diff / 1000) % 60),
      done: false,
    };
  }, [target]);

  const [t, setT] = useState(compute());

  useEffect(() => {
    const id = setInterval(() => setT(compute()), 1000);
    return () => clearInterval(id);
  }, [compute]);

  const units = [
    { v: t.d, l: 'Days' },
    { v: t.h, l: 'Hours' },
    { v: t.m, l: 'Mins' },
    { v: t.s, l: 'Secs' },
  ];

  return (
    <div className="inline-block">
      <div className="flex items-center gap-2 mb-3">
        <span className="w-2 h-2 rounded-full bg-[#c8a24c] animate-pulse" />
        <span className="text-[#dcbf74] text-xs md:text-sm font-semibold tracking-[0.25em] uppercase">
          {t.done ? 'The day is here!' : label}
        </span>
      </div>
      <div className="flex gap-2.5 sm:gap-3">
        {units.map((u, i) => (
          <div
            key={u.l}
            className="relative flex flex-col items-center justify-center rounded-2xl bg-white/10 backdrop-blur-md border border-[#c8a24c]/40 shadow-lg px-3 py-2.5 sm:px-4 sm:py-3 min-w-[62px] sm:min-w-[76px]"
            style={{ animation: `fadeUp 0.6s ease both`, animationDelay: `${0.15 + i * 0.08}s` }}
          >
            <span className="font-serif-display text-white text-2xl sm:text-4xl font-bold leading-none tabular-nums">
              {pad(u.v)}
            </span>
            <span className="mt-1 text-[#dcbf74]/90 text-[9px] sm:text-[11px] font-semibold tracking-[0.15em] uppercase">
              {u.l}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Countdown;
